import type { ComponentType } from "react";
import type { WithConfigProps } from "./types";
import ConfigProvider from "./ConfigProvider";
import Config from "./Config";

export const withConfig = <TProps extends object>(Component: ComponentType<WithConfigProps<TProps>>) =>
    ({ config = new Config(), ...restProps }: WithConfigProps<TProps>) => (
        <ConfigProvider
            value={config}
        >
            <Component
                {...restProps as TProps}
            />
        </ConfigProvider>
    );
